import DriverDto from 'app/admin/driver/dto/DriverDto';
import NamedDto from 'modules/base/dto/NamedDto';

export class OptimizerTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
	}

	/**
	 * @typedef {Object} _OptimizerTableDtoProps
	 * @property {string} type
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizerTableDtoProps} OptimizerTableDtoProps
	 */
	/**
	 *
	 * @param {OptimizerTableDtoProps} props
	 * @returns {OptimizerTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		return this;
	}
}

export default OptimizerTableDto;
